// Code generated by @hex-insights/frontend-generator; DO NOT EDIT.
import { announcementHubDetailPageInfo } from "./Pages/Hubs/Announcement/DetailPage/pageinfo";
import { calendarEventHubDetailPageInfo } from "./Pages/Hubs/CalendarEvent/DetailPage/pageinfo";
import { newsletterHubDetailPageInfo } from "./Pages/Hubs/Newsletter/DetailPage/pageinfo";
import { permissionGroupHubDetailPageInfo } from "./Pages/Hubs/PermissionGroup/DetailPage/pageinfo";
import { postHubDetailPageInfo } from "./Pages/Hubs/Post/DetailPage/pageinfo";
import { userHubDetailPageInfo } from "./Pages/Hubs/User/DetailPage/pageinfo";
import { userGroupHubDetailPageInfo } from "./Pages/Hubs/UserGroup/DetailPage/pageinfo";

export const hubDetailPages = {
	Announcement: announcementHubDetailPageInfo,
	CalendarEvent: calendarEventHubDetailPageInfo,
	Newsletter: newsletterHubDetailPageInfo,
	PermissionGroup: permissionGroupHubDetailPageInfo,
	Post: postHubDetailPageInfo,
	User: userHubDetailPageInfo,
	UserGroup: userGroupHubDetailPageInfo,
};
